import { render, staticRenderFns } from "./VSupplier.vue?vue&type=template&id=502ceb22"
import script from "./VSupplier.vue?vue&type=script&lang=js"
export * from "./VSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports